"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/floating-orbs.tsx
import { cn } from "@base/utils/cn";
import { motion } from "framer-motion";
import { jsx, jsxs } from "react/jsx-runtime";
var defaultOrbs = [
  {
    size: "600px",
    color: "from-purple-9/30 to-violet-9/20",
    opacity: 0.5,
    blur: "blur-[100px]",
    animationDelay: 0,
    position: { x: 20, y: 10 },
    glowIntensity: 1.2
  },
  {
    size: "500px",
    color: "from-blue-9/25 to-indigo-9/20",
    opacity: 0.4,
    blur: "blur-[80px]",
    animationDelay: 2,
    position: { x: 70, y: 60 },
    glowIntensity: 1
  },
  {
    size: "400px",
    color: "from-pink-9/20 to-plum-9/15",
    opacity: 0.3,
    blur: "blur-[60px]",
    animationDelay: 4,
    position: { x: 40, y: 80 },
    glowIntensity: 0.8
  }
];
function FloatingOrbs({ orbs = defaultOrbs, intensity = 1, className }) {
  return /* @__PURE__ */ jsxs("div", { className: cn("absolute inset-0 overflow-\
hidden pointer-events-none", className), children: [
    orbs.map((orb, _index) => /* @__PURE__ */ jsx(
      motion.div,
      {
        className: cn(
          "absolute rounded-full",
          "bg-gradient-to-br",
          orb.color,
          orb.blur || "blur-3xl",
          "will-change-transform"
        ),
        style: {
          width: orb.size,
          height: orb.size,
          left: `${orb.position.x}%`,
          top: `${orb.position.y}%`,
          opacity: orb.opacity * intensity,
          transform: "translate(-50%, -50%)",
          filter: `blur(${100 * (orb.glowIntensity || 1)}px)`
        },
        animate: {
          x: [0, 30 * intensity, -20 * intensity, 0],
          y: [0, -25 * intensity, 15 * intensity, 0],
          scale: [1, 1.1, 0.95, 1]
        },
        transition: {
          duration: 20 + orb.animationDelay * 2,
          repeat: Infinity,
          delay: orb.animationDelay,
          ease: "easeInOut"
        }
      },
      `orb-${orb.position.x}-${orb.position.y}-${orb.size}`
    )),
    orbs.map((orb) => /* @__PURE__ */ jsx(
      motion.div,
      {
        className: cn(
          "absolute rounded-full",
          "bg-gradient-radial",
          orb.color,
          "blur-[120px]",
          "mix-blend-screen dark:mix-blend-plus-lighter"
        ),
        style: {
          width: `calc(${orb.size} * 1.5)`,
          height: `calc(${orb.size} * 1.5)`,
          left: `${orb.position.x}%`,
          top: `${orb.position.y}%`,
          opacity: orb.opacity * intensity * 0.3,
          transform: "translate(-50%, -50%)"
        },
        animate: {
          scale: [1, 1.2, 1],
          opacity: [orb.opacity * 0.3, orb.opacity * 0.5, orb.opacity * 0.3]
        },
        transition: {
          duration: 15 + orb.animationDelay,
          repeat: Infinity,
          delay: orb.animationDelay + 1,
          ease: "easeInOut"
        }
      },
      `orb-glow-${orb.position.x}-${orb.position.y}-${orb.size}`
    ))
  ] });
}
__name(FloatingOrbs, "FloatingOrbs");
export {
  FloatingOrbs
};
